module.exports = __webpack_public_path__ + "img/American_Amicable_logo_recreated_BLACK_19-07-09@2x.3b8318e7.png";